import { render, staticRenderFns } from "./ChangeFacility.vue?vue&type=template&id=3c188f7b&scoped=true&"
import script from "./ChangeFacility.vue?vue&type=script&lang=js&"
export * from "./ChangeFacility.vue?vue&type=script&lang=js&"
import style0 from "./ChangeFacility.vue?vue&type=style&index=0&id=3c188f7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c188f7b",
  null
  
)

export default component.exports